export const BANK_ACCOUNT_NAME_MAX_CHARS = 140;
const IBAN_SHAPE = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/;
// Bank code (4 letters), country (2 letters), location (2), and an optional branch (3).
const BIC_SHAPE = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
/** ISO 13616: the first four characters moved to the end, letters as 10-35, the number mod 97 is 1. */
function ibanChecksumOk(iban) {
    let remainder = 0;
    for (const ch of iban.slice(4) + iban.slice(0, 4)) {
        const digits = ch >= 'A' && ch <= 'Z' ? String(ch.charCodeAt(0) - 55) : ch;
        for (const digit of digits)
            remainder = (remainder * 10 + Number(digit)) % 97;
    }
    return remainder === 1;
}
const isOptionalString = (v) => v === undefined || v === null || typeof v === 'string';
/** Checks the IBAN, then the BIC, then the name: the account as stored, or the first problem. */
export function checkBankAccount(fields) {
    if (!isOptionalString(fields.iban))
        return { ok: false, problem: 'iban_not_string' };
    const iban = typeof fields.iban === 'string' ? fields.iban.replace(/\s+/g, '').toUpperCase() : '';
    if (iban === '')
        return { ok: false, problem: 'iban_missing' };
    if (!IBAN_SHAPE.test(iban))
        return { ok: false, problem: 'iban_shape' };
    if (!ibanChecksumOk(iban))
        return { ok: false, problem: 'iban_checksum' };
    if (!isOptionalString(fields.bic))
        return { ok: false, problem: 'bic_not_string' };
    const bic = typeof fields.bic === 'string' ? fields.bic.replace(/\s+/g, '').toUpperCase() : '';
    if (bic !== '' && !BIC_SHAPE.test(bic))
        return { ok: false, problem: 'bic_shape' };
    if (!isOptionalString(fields.accountName))
        return { ok: false, problem: 'account_name_not_string' };
    const accountName = typeof fields.accountName === 'string' ? fields.accountName.trim() : '';
    // Code points, as the VARCHAR(140) column counts them.
    if ([...accountName].length > BANK_ACCOUNT_NAME_MAX_CHARS)
        return { ok: false, problem: 'account_name_too_long' };
    return { ok: true, value: { iban, bic: bic === '' ? null : bic, accountName: accountName === '' ? null : accountName } };
}
//# sourceMappingURL=bank-account.js.map